import { useContext, useEffect } from 'react';
import { InitialDataContext } from './InitialData';
import { useLocation } from 'react-router-dom';
import { buildPageSeo, serializeJson } from './metadata';

export default function PageSeo({ item, unavailable = false }) {
  const { pathname, search } = useLocation();
  const exportConfig = useContext(InitialDataContext);
  const serialized = serializeJson(buildPageSeo(pathname, item, {
    noindex: exportConfig.indexable === false || unavailable || Boolean(search) || (typeof window !== 'undefined' && window.location.hostname !== 'starekomputery.pl'),
    apiUrl: process.env.REACT_APP_STRAPI_BASE_URL,
  }));
  useEffect(() => {
    const seo = JSON.parse(serialized);
    document.title = seo.title;
    const setTag = (selector, name, value, attribute = 'name') => {
      let tag = document.head.querySelector(selector);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attribute, name);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', value);
    };
    setTag('meta[name="description"]', 'description', seo.description);
    setTag('meta[name="robots"]', 'robots', seo.robots);
    for (const [name, content] of Object.entries({ 'og:title': seo.title, 'og:description': seo.description, 'og:url': seo.canonical, 'og:type': 'website', 'og:site_name': 'StareKomputery.pl', 'og:locale': 'pl_PL', 'og:image': seo.image, 'og:image:alt': seo.imageAlt })) setTag(`meta[property="${name}"]`, name, content, 'property');
    setTag('meta[name="twitter:card"]', 'twitter:card', 'summary_large_image');
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement('link'); canonical.rel = 'canonical'; document.head.appendChild(canonical); }
    canonical.href = seo.canonical;
    let structured = document.getElementById('page-schema');
    if (!structured) { structured = document.createElement('script'); structured.id = 'page-schema'; structured.type = 'application/ld+json'; document.head.appendChild(structured); }
    structured.textContent = serializeJson(seo.schema);
  }, [serialized]);
  return null;
}
